<div class="wrap">
    <img [src]="url" alt="icone">
</div>